var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurgery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "_x32_",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    style: {},
    transform: "matrix(0.605808, 0, 0, 0.595125, 90.837082, 92.641754)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,469.672c165.186-2.367,233.663-157.399,233.663-157.399l-84.18-58.331L0,469.672z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.621,291.723l130.158-187.87c11.418-16.466,7.328-39.078-9.147-50.496l-40.327-27.926 c-16.459-11.41-39.069-7.32-50.488,9.155l-130.174,187.87c-4.284,6.176-2.738,14.647,3.446,18.931l77.593,53.766 C248.866,299.445,257.336,297.899,261.621,291.723z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.875,465.436c-7.634,0-13.802,6.168-13.802,13.793c0,7.618,6.168,13.802,13.802,13.802 c7.617,0,13.786-6.184,13.786-13.802C117.661,471.604,111.492,465.436,103.875,465.436z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.193,465.436c-7.617,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.634,0,13.818-6.184,13.818-13.802C174.011,471.604,167.827,465.436,160.193,465.436z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.527,465.436c-7.617,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.618,0,13.802-6.184,13.802-13.802C230.33,471.604,224.145,465.436,216.527,465.436z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.862,465.436c-7.618,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.633,0,13.801-6.184,13.801-13.802C286.663,471.604,280.495,465.436,272.862,465.436z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.196,465.436c-7.618,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.617,0,13.801-6.184,13.801-13.802C342.997,471.604,336.813,465.436,329.196,465.436z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.53,465.436c-7.618,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.618,0,13.802-6.184,13.802-13.802C399.332,471.604,393.148,465.436,385.53,465.436z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.865,465.436c-7.618,0-13.802,6.168-13.802,13.793c0,7.618,6.184,13.802,13.802,13.802 c7.617,0,13.801-6.184,13.801-13.802C455.666,471.604,449.482,465.436,441.865,465.436z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.198,465.436c-7.634,0-13.801,6.168-13.801,13.793c0,7.618,6.168,13.802,13.801,13.802 c7.618,0,13.802-6.184,13.802-13.802C512,471.604,505.816,465.436,498.198,465.436z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgery);
export default __webpack_public_path__ + "static/media/surgery.f0efe637b9ac63b8eb637d8a20289888.svg";
export { ForwardRef as ReactComponent };